import { Icon, type IconNameType, IconVariant } from "@quortex/front-common"
import type { FC } from "react"

interface Props {
  name: string
  icon: IconNameType
  iconType?: IconVariant
}

const NameTD: FC<Props> = ({ name, icon, iconType = IconVariant.SOLID }) => (
  <td className="w-0 whitespace-nowrap p-0 pr-sm align-middle text-sm">
    <div className="flex gap-xs">
      <Icon icon={icon} size={20} type={iconType} />
      <div>{name}</div>
    </div>
  </td>
)

export default NameTD
